import React from 'react'
import { useTranslation } from 'react-i18next'
import { InfoSheetPanel } from '@fs/zion-ui'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import EditHouseholdContent from './EditHouseholdContent'

const EditHouseholdPanel = () => {
  const [t] = useTranslation()
  const { editHouseholdOverlay } = useOverlayContext()

  return (
    <InfoSheetPanel
      {...editHouseholdOverlay}
      title={t('edit-household.heading', 'Edit Households')}
      headingColor="yellow"
    >
      <EditHouseholdContent />
    </InfoSheetPanel>
  )
}

export default EditHouseholdPanel
